import React from 'react';

import { ForethoughtContext } from '@modules/support/forethought';
import { ZendeskContext } from '@modules/support/zendesk';

const ChatContext: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <ForethoughtContext>
      <ZendeskContext>{children}</ZendeskContext>
    </ForethoughtContext>
  );
};

export default ChatContext;
